<div class="message-banner" [ngStyle]="{'display': (isClosed | async) ? 'none' : 'flex' }" *ngIf="message">
    <span *ngIf="!isLink">{{ message }} </span>
    <a *ngIf="isLink" [href]="link" target="_blank">{{ message }}</a>
    <div>
        <a *ngIf="buttonName" mat-stroked-button color="primary" (click)="buttonClick.emit()">
            {{ buttonName }}
        </a>
        <button mat-icon-button (click)="closeBanner()">
            <mat-icon>close</mat-icon>
        </button>
    </div>
</div>